import { Text } from '@comicrelief/component-library';

const CopyTop = (
  <>
    <Text tag="p">
      We’d love to send you updates about the projects Comic Relief funds and other ways you can support our work.
    </Text>
    <Text tag="p" weight="bold">
      How would you like to hear from us?
    </Text>
  </>
);

export default CopyTop;
